import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import downloadIcon from "../assets/icons/download.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step1_en from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step1_en.png";
import step2_en from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step2_en.png";
import step3_en from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step3_en.png";
import step4_en from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step4_en.png";
import step5_en from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step5_en.png";
import step1_vi from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step1_vi.png";
import step2_vi from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step2_vi.png";
import step3_vi from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step3_vi.png";
import step4_vi from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step4_vi.png";
import step5_vi from "../assets/image/guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS/step5_vi.png";


const GuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-08-20";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return `
${t("sidebar.install.itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS")}

${t("guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step1").replace(/<[^>]+>/g, "")}

${t("guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step2").replace(/<[^>]+>/g, "")}

${t("guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step3").replace(/<[^>]+>/g, "")}

${t("guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step4").replace(/<[^>]+>/g, "")}

${t("guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step5").replace(/<[^>]+>/g, "")}
    `.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={downloadIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.install.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.install.itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: lang === "en" ? step1_en : step1_vi

                        }}>
                            <img
                                src={lang === "en" ? step1_en : step1_vi}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: lang === "en" ? step2_en : step2_vi

                        }}>
                            <img
                                src={lang === "en" ? step2_en : step2_vi}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: lang === "en" ? step3_en : step3_vi

                        }}>
                            <img
                                src={lang === "en" ? step3_en : step3_vi}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: lang === "en" ? step4_en : step4_vi

                        }}>
                            <img
                                src={lang === "en" ? step4_en : step4_vi}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: lang === "en" ? step5_en : step5_vi

                        }}>
                            <img
                                src={lang === "en" ? step5_en : step5_vi}
                                alt="controlpanel"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col tabletpro:flex-row desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.install.itemUninstall")}
                            to="/uninstall-gopaperlessagent"
                        />
                        <NextSectionCard
                            label={t("sidebar.usage.title")}
                            to="/userguide"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default GuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS
